/*
 * Copyright (c) 2014-present, Prezzee
 * All rights reserved.
 */

/**
 * Function flow
 * @param f1
 * @param f2
 */
export const flow =
  <T, S>(f1: (arg: S) => T, f2: (arg: any) => S) =>
  (arg: any) =>
    f1(f2(arg));
/**
 * Function list flow
 * @param arr
 */
export const flowList = <T>(arr: ((arg: any) => any)[]): any => arr.reduce(flow, value => value);
/**
 * Run function with arg
 * @param fn
 */
export const run =
  <T>(fn: Function): ((arg: any) => T) =>
  (arg: any): T =>
    fn(arg);

/**
 * Identity func
 * @param arg
 */
export const identity = <T = any>(arg: T) => arg;
